import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {decode} from 'html-entities';
import parse from 'html-react-parser';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import {CREATE_FLOWS} from '../../../constants';
import {DARK_TEXT_COLOR, GREY_BACKGROUND_HOVER} from '../../../theme';
import {PriorPresentationFormatSelect} from './_PresentationFormatSelect';
import {styles} from './CreateDocumentModal.styles';

// Co-located styles for this component
const localStyles = {
  boldLabel: {
    color: DARK_TEXT_COLOR,
    fontSize: '0.875rem',
    fontWeight: '700',
    lineHeight: '140%',
  },
  container: {
    backgroundColor: GREY_BACKGROUND_HOVER,
    padding: '1.5rem',
  },
};

export const PreviousDocumentList = ({
  createFlow,
  isProcessing,
  onPreviousDocumentChange,
  previousDocument,
  previousDocuments,
  previousPresentationFormat,
  previousPresentationFormatTouched,
  setPreviousPresentationFormat,
  setPreviousPresentationFormatTouched,
}) => {
  if (createFlow !== CREATE_FLOWS.rollforward || isProcessing) {
    return null;
  }

  return (
    <Stack direction="column" spacing="1rem" sx={localStyles.container}>
      <Typography style={localStyles.boldLabel}>
        Existing report to rollforward:
      </Typography>
      <FormControl>
        <Select
          id="createDocument-previousDocument-select"
          onChange={onPreviousDocumentChange}
          sx={styles.modal.select}
          value={_.get(previousDocument, 'documentId', '')}
        >
          {_.map(previousDocuments, (_document) => (
            <MenuItem key={_document.documentId} value={_document.documentId}>
              {parse(decode(_document.name))}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <PriorPresentationFormatSelect
        previousDocument={previousDocument}
        previousPresentationFormat={previousPresentationFormat}
        previousPresentationFormatTouched={previousPresentationFormatTouched}
        setPreviousPresentationFormat={setPreviousPresentationFormat}
        setPreviousPresentationFormatTouched={
          setPreviousPresentationFormatTouched
        }
      />
    </Stack>
  );
};

PreviousDocumentList.propTypes = {
  createFlow: PropTypes.string,
  isProcessing: PropTypes.bool.isRequired,
  onPreviousDocumentChange: PropTypes.func.isRequired,
  previousDocument: PropTypes.object,
  previousDocuments: PropTypes.array,
  previousPresentationFormat: PropTypes.string.isRequired,
  previousPresentationFormatTouched: PropTypes.bool.isRequired,
  setPreviousPresentationFormat: PropTypes.func.isRequired,
  setPreviousPresentationFormatTouched: PropTypes.func.isRequired,
};
